import React from 'react'
import { createRoot } from 'react-dom/client'

import PreferenceBar from './PreferenceBar.jsx'

import './index.css'

class PreferenceBarElement extends HTMLElement {
  connectedCallback() {
    const stamp = Math.floor(Math.random() * 10000)
    const reactContainerId = `preference-bar-react-app${stamp}`
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const site = this.getAttribute('site')

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(<PreferenceBar site={site} />)
  }
}

customElements.define('preference-bar', PreferenceBarElement)
